import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";

// Prints only the code area: everything else on the page is hidden by the print stylesheet.
const PRINT_CSS = `@media print {
  body * { visibility: hidden !important; }
  #tc-printed-code, #tc-printed-code * { visibility: visible !important; }
  #tc-printed-code { position: fixed; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; background: #fff; }
}`;

/** A large, non-rotating code laid out for paper. Scans of it must be from inside the room, which the server enforces. */
export default function PrintedCodeView({ url, session, onBack }) {
  return (
    <Box>
      <style>{PRINT_CSS}</style>
      <Box id="tc-printed-code" data-testid="printed-code-area" sx={{ textAlign: "center", p: 2 }}>
        <Typography component="h2" variant="h5" sx={{ fontWeight: 700 }}>{session.name}</Typography>
        {session.location && <Typography color="text.secondary">{session.location}</Typography>}
        {session.date && <Typography color="text.secondary" sx={{ mb: 2 }}>{session.date}</Typography>}
        <QRCodeSVG value={url} size={320} level="M" includeMargin={false} />
        <Typography sx={{ mt: 2, fontWeight: 700, fontSize: "1.1rem" }}>Scan to check in</Typography>
        <Typography color="text.secondary">You must be in the room for your check-in to count.</Typography>
      </Box>
      <Typography color="text.secondary" sx={{ fontSize: "0.8rem", textAlign: "center", mt: 1 }}>
        This code is valid for 36 hours and only works from inside the room.
      </Typography>
      <Box sx={{ display: "flex", gap: 1, justifyContent: "center", mt: 2 }}>
        <Button onClick={onBack} sx={{ textTransform: "none" }}>Back to live code</Button>
        <Button variant="contained" onClick={() => window.print()} sx={{ textTransform: "none" }}>Print</Button>
      </Box>
    </Box>
  );
}
